import { StatusRequest } from '@core/models/request-status.model';

export const ANONYMOUS_USER_NAME = 'ANONYMOUS';

export interface Customer extends StatusRequest {
  id?: string;
  uid?: string;
  username?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  name?: string;
  isAuthenticated?: boolean;
  type?: 'customer';
}
